function noReact(value) {
    return JSON.parse(JSON.stringify(value))
}

export default noReact